var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: 0.691406,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.082 18.8164H8.33203C8.00051 18.8164 7.68257 18.6847 7.44815 18.4503C7.21373 18.2159 7.08203 17.8979 7.08203 17.5664V8.81641C7.08203 8.48489 7.21373 8.16694 7.44815 7.93252C7.68257 7.6981 8.00051 7.56641 8.33203 7.56641H15.207L18.332 10.6914V17.5664C18.332 17.8979 18.2003 18.2159 17.9659 18.4503C17.7315 18.6847 17.4136 18.8164 17.082 18.8164Z",
    stroke: "#E52333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.832 18.8164V13.8164H9.58203V18.8164",
    stroke: "#E52333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 7.56641V10.6914H14.582",
    stroke: "#E52333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.f2681dcd0a1abbe7647e4c0b4d5a1152.svg";
export { ForwardRef as ReactComponent };